/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_list__aria_label__filter_button_filtered__one = /** @type {(inputs: { numberOfFilters: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.numberOfFilters} aktivierter Filter`
};

const en_poi_list__aria_label__filter_button_filtered__one = /** @type {(inputs: { numberOfFilters: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.numberOfFilters} filter activated`
};

const es_poi_list__aria_label__filter_button_filtered__one = /** @type {(inputs: { numberOfFilters: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.numberOfFilters} filtro activado`
};

const fr_poi_list__aria_label__filter_button_filtered__one = /** @type {(inputs: { numberOfFilters: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.numberOfFilters} filtre activé`
};

const it_poi_list__aria_label__filter_button_filtered__one = /** @type {(inputs: { numberOfFilters: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.numberOfFilters} filtro attivato`
};

const nl_poi_list__aria_label__filter_button_filtered__one = /** @type {(inputs: { numberOfFilters: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.numberOfFilters} filter geactiveerd`
};

const pt_poi_list__aria_label__filter_button_filtered__one = /** @type {(inputs: { numberOfFilters: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.numberOfFilters} filtro ativado`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ numberOfFilters: NonNullable<unknown> }} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__aria_label__filter_button_filtered__one = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_list__aria_label__filter_button_filtered__one(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_list__aria_label__filter_button_filtered__one", locale)
	if (locale === "de") return de_poi_list__aria_label__filter_button_filtered__one(inputs)
	if (locale === "en") return en_poi_list__aria_label__filter_button_filtered__one(inputs)
	if (locale === "es") return es_poi_list__aria_label__filter_button_filtered__one(inputs)
	if (locale === "fr") return fr_poi_list__aria_label__filter_button_filtered__one(inputs)
	if (locale === "it") return it_poi_list__aria_label__filter_button_filtered__one(inputs)
	if (locale === "nl") return nl_poi_list__aria_label__filter_button_filtered__one(inputs)
	return pt_poi_list__aria_label__filter_button_filtered__one(inputs)
};